export default {
  path: 'banners',
  name: 'banners',
  redirect: { name: 'banners.index' },
  children: [
    {
      path: '',
      name: 'banners.index',
      component: () => import('pages/banners/IndexPage.vue'),
    },
    {
      path: 'create',
      name: 'banners.create',
      component: () => import('pages/banners/CreatePage.vue'),
    },
    {
      path: ':id',
      name: 'banners.read',
      component: () => import('pages/banners/ReadPage.vue'),
    },
    {
      path: 'update/:id',
      name: 'banners.update',
      component: () => import('pages/banners/CreatePage.vue'),
    },
  ],
}
